<div class="container">
    <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width: 100%"></table>

    <ng-template #actionsRef let-data="adtData" let-emitter="captureEvents">
        <app-edit [data]="data" (emitter)="emitter($event)"></app-edit>
    </ng-template>
</div>
